import React, { useEffect, useState } from "react";
import { Button, Row, Col } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import SearchPlaces from "../SearchPlaces/SearchPlaces";
import { googlePlacesParser } from "../DetailPane/_DetailPane.helpers";
import { l } from "../../libs/localization";

const Address = (props) => {
  const {
    style,
    searchStyle,
    editing,
    dataForm,
    onChange,
    searchPlaceholder,
    formattedAddressPlaceholder,
    showFormatted = true,
    showNote = true,
  } = props;

  const [formattedAddress, setFormattedAddress] = useState();

  useEffect(() => {
    if (dataForm) {
      setFormattedAddress(getFormattedAddress(dataForm));
    }
  }, [dataForm]);

  const getFormattedAddress = (data) => {
    if (data && data.address) {
      return (
        <div>
          <p>{data.address || "-"}</p>
          <p>
            {data.CP ? `${data.CP} - ` : ""}
            {data.city}
            {data.province ? ` (${data.province}) - ` : ""}
            {data.region ? `${data.region}, ` : ""}
            {data.nation}
          </p>
        </div>
      );
    }
    return "";
  };

  const getStringAddress = (data) => {
    if (data && data.address) {
      return `${data.address || ""}, ${data.CP || ""} ${data.city || ""} ${
        data.province || ""
      }${data.region ? ` (${data.region})` : ""}, ${data.nation || ""}`;
    }
    return "";
  };

  const isMultiple = dataForm && Array.isArray(dataForm.addresses);

  if (isMultiple) {
    const addresses = dataForm.addresses || [];

    const handleAddressChange = (index, parsedAddress) => {
      const updated = [...addresses];
      updated[index] = {
        ...updated[index],
        ...parsedAddress,
      };
      triggerChange(updated);
    };

    const handleNotesChange = (index, notes) => {
      const updated = [...addresses];
      updated[index] = {
        ...updated[index],
        addressNotes: notes,
      };
      triggerChange(updated);
    };

    const handleAddAddress = () => {
      const updated = [
        ...addresses,
        {
          address: "",
          city: "",
          CP: "",
          province: "",
          region: "",
          nation: "",
          position: null,
          addressNotes: "",
        },
      ];
      triggerChange(updated);
    };

    const handleRemoveAddress = (index) => {
      const updated = addresses.filter((_, idx) => idx !== index);
      triggerChange(updated);
    };

    const triggerChange = (newAddresses) => {
      const firstAddress = newAddresses[0] || {};
      onChange({
        ...dataForm,
        addresses: newAddresses,
        address: firstAddress.address || "",
        city: firstAddress.city || "",
        CP: firstAddress.CP || "",
        province: firstAddress.province || "",
        region: firstAddress.region || "",
        nation: firstAddress.nation || "",
        position: firstAddress.position || null,
        addressNotes: firstAddress.addressNotes || "",
      });
    };

    return (
      <Col span={24} style={{ padding: "10px 0" }}>
        {addresses.length === 0 && !editing && (
          <p style={{ opacity: 0.6 }}>{formattedAddressPlaceholder || l("COMMON.NO_DATA")}</p>
        )}
        {addresses.map((addr, idx) => (
          <div
            key={addr._id || idx}
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              padding: "16px",
              marginBottom: "16px",
              backgroundColor: "#fafafa",
              position: "relative",
            }}
          >
            {editing && (
              <button
                type="button"
                onClick={() => handleRemoveAddress(idx)}
                style={{
                  position: "absolute",
                  top: "12px",
                  right: "12px",
                  border: "none",
                  background: "transparent",
                  color: "#ff4d4f",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
                title={l("COMMON.DELETE")}
              >
                <DeleteOutlined />
              </button>
            )}
            <div style={{ marginBottom: "12px" }}>
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#262626",
                }}
              >
                {l("COMMON.ADDRESS")} {addresses.length > 1 ? `#${idx + 1}` : ""}
              </span>
            </div>
            {editing ? (
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <div style={{ marginBottom: "8px" }}>
                    <b>{searchPlaceholder}:</b>
                  </div>
                  <SearchPlaces
                    placeInput={addr.address ? getStringAddress(addr) : ""}
                    searchPlaceholder={searchPlaceholder}
                    onChange={(gplace) => {
                      if (!gplace) {
                        handleAddressChange(idx, {
                          address: "",
                          city: "",
                          nation: "",
                          CP: "",
                          province: "",
                          region: "",
                          position: null,
                        });
                        return;
                      }
                      const { address_components, geometry } = gplace;
                      const place = googlePlacesParser(address_components);
                      const { location } = geometry || {};

                      if (place && location) {
                        const {
                          street_number,
                          route,
                          locality,
                          postal_town,
                          administrative_area_level_3: hamlet,
                          administrative_area_level_2: province,
                          administrative_area_level_1: region,
                          country: nation,
                          postal_code: CP,
                        } = place;
                        const city = locality || hamlet || postal_town;
                        handleAddressChange(idx, {
                          address: `${route || ""} ${street_number || ""}`,
                          region,
                          province,
                          CP,
                          city,
                          nation,
                          position: {
                            lat: location.lat(),
                            lng: location.lng(),
                          },
                        });
                      }
                    }}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <div style={{ marginBottom: "8px" }}>
                    <b>{l("COMMON.ADDRESS_NOTE")}:</b>
                  </div>
                  <textarea
                    className="ant-input"
                    value={addr.addressNotes || ""}
                    placeholder="—"
                    onChange={(e) => handleNotesChange(idx, e.target.value)}
                    rows={2}
                  />
                </Col>
              </Row>
            ) : (
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <div>{getFormattedAddress(addr)}</div>
                </Col>
                {addr.addressNotes && (
                  <Col xs={24} md={12}>
                    <div>
                      <b>{l("COMMON.ADDRESS_NOTE")}:</b>
                      <p style={{ margin: "4px 0 0 0" }}>{addr.addressNotes}</p>
                    </div>
                  </Col>
                )}
              </Row>
            )}
          </div>
        ))}

        {editing && (
          <Button
            type="dashed"
            onClick={handleAddAddress}
            block
            style={{
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderColor: "#d9d9d9",
            }}
          >
            <PlusOutlined /> {l("COMMON.ADD_ADDRESS")}
          </Button>
        )}
      </Col>
    );
  }

  return (
    <>
      {editing && (
        <Col style={{ ...searchStyle }}>
          <div style={{ minWidth: "300px" }}>
            <b>{searchPlaceholder}:</b>
            <SearchPlaces
              placeInput={
                dataForm.address
                  ? getStringAddress(dataForm)
                  : ""
              }
              searchPlaceholder={searchPlaceholder}
              onChange={(gplace) => {
                const { address_components, geometry } = gplace;
                const place = googlePlacesParser(address_components);
                const { location } = geometry || {};

                if (place && location) {
                  const {
                    street_number,
                    route,
                    locality,
                    postal_town,
                    administrative_area_level_3: hamlet,
                    administrative_area_level_2: province,
                    administrative_area_level_1: region,
                    country: nation,
                    postal_code: CP,
                  } = place;

                  const city = locality || hamlet || postal_town;

                  const dataAddress = {
                    address: `${route || ""} ${street_number || ""}`,
                    region,
                    province,
                    CP,
                    city,
                    nation,
                    position: {
                      lat: location.lat(),
                      lng: location.lng(),
                    },
                  };

                  setFormattedAddress(getFormattedAddress(dataAddress));

                  onChange({
                    ...dataForm,
                    ...dataAddress,
                  });
                } else {
                  const dataAddress = {
                    address: "",
                    city: "",
                    nation: "",
                  };
                  onChange({
                    ...dataForm,
                    ...dataAddress,
                  });
                }
              }}
            />
          </div>
        </Col>
      )}
      {(showFormatted || formattedAddressPlaceholder) && (
        <Col style={style}>
          <p>
            <b>{l("COMMON.ADDRESS")}:</b>
          </p>
          <div>
            {dataForm.address ? formattedAddress : formattedAddressPlaceholder}
          </div>
        </Col>
      )}
      {showNote && (
        <Col style={style}>
          <p>
            <b>{l("COMMON.ADDRESS_NOTE")}:</b>
          </p>
          <p>
            <textarea
              disabled={!editing}
              className="ant-input"
              value={dataForm.addressNotes}
              placeholder="—"
              onChange={(e) => {
                onChange({
                  ...dataForm,
                  addressNotes: e.target.value,
                });
              }}
            />
          </p>
        </Col>
      )}
    </>
  );
};

export default Address;
